import { connect, Dispatch } from 'react-redux';
import {
  UpdateNmvsProviderCredentialsAction,
  UpdateTenantPreferencesAction,
  SetSettingsErrorMessageAction,
  GetTenantAction
} from './actions';
import { SettingsPage } from './component';
import { AppState } from '../app/state';
import { NmvsProviderCredentials } from 'types/tenants/nmvs-provider-credentials';
import { Guid } from 'types/guid';
import { connectionSelector } from 'components/connection-status/selectors';
import { permissionsSelector } from 'pages/login/selectors';
import { tenantSelector } from './selectors';

const mapStateToProps = (state: AppState) => {
  return {
    isOnline: connectionSelector(state),
    isProcessing: state.settings.isProcessing,
    languageOptions: state.settings.languageOptions,
    permissions: permissionsSelector(state),
    tenant: tenantSelector(state)
  };
};

function mapDispatchToProps(dispatch: Dispatch<UpdateTenantPreferencesAction>): object {
  return {
    getTenant: () => dispatch(new GetTenantAction()),
    updateTenantPreferences: (tenantId: Guid, language: string) =>
      dispatch(new UpdateTenantPreferencesAction(tenantId, language)),
    updateNmvsProviderCredentials: (tenantId: Guid, nmvsProviderCredentials: NmvsProviderCredentials) =>
      dispatch(new UpdateNmvsProviderCredentialsAction(tenantId, nmvsProviderCredentials)),
    clearErrorMessage: () => dispatch(new SetSettingsErrorMessageAction(''))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);


// WEBPACK FOOTER //
// ./src/pages/settings/index.ts